export default "__VITE_ASSET__DtiaeBSD__"